import { render, staticRenderFns } from "./RuleName.vue?vue&type=template&id=ce0428d0&scoped=true&"
import script from "./RuleName.vue?vue&type=script&lang=ts&"
export * from "./RuleName.vue?vue&type=script&lang=ts&"
import style0 from "./RuleName.vue?vue&type=style&index=0&id=ce0428d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0428d0",
  null
  
)

export default component.exports